let elementsSelector = '.js-readmore';
let attrTabs = 'data-tabs';
let animationDuration = 200;
let readMoreSelector = elementsSelector;

initTabs();

export function initTabs() {
	
	var options = {
		hide: animationDuration,
		show: animationDuration,
		classes: {
			"ui-tabs-active": "active",
		},
		beforeActivate: function (event, ui) {
			
			updateReadMoreHeight(event, ui);
			setActiveElementLavalamp(event, ui);
		},
		create: function (event, ui) {
			createLavalamp(event, ui);
		},
	};
	
	var $tabs = $('[' + attrTabs + ']');
	
	$tabs.each(function (i, el) {
		
		var $tabBox = prepareTabBox($(el));
		
		$tabBox.tabs(options);
		watchCSS($tabBox, options);
		
	});
	
	// Создание анимации на заголовках вкладок
	function createLavalamp(event, ui) {
		
		var $tabsList = $(event.target).find('.ui-tabs-nav');
		
		var lavalamp = new Lavalamp($tabsList[0], {
			enableHover: false,
			duration: 300,
		});
		
		
		$tabsList.data('lavalamp', lavalamp);
		
	}
	
	function setActiveElementLavalamp(event, ui) {
		
		var $tabsList = $(event.target).find('.ui-tabs-nav');
		var lavalamp = $tabsList.data('lavalamp');
		var newElement = ui.newTab[0];
		
		lavalamp.setActiveElement(newElement);
		
	}
	
	// Возможность отключать табы через CSS
	function watchCSS($el, options) {
		
		var runWatchCSS = function () {
			if ($el.length == 1) {
				
				var afterContent = getComputedStyle($el[0], ':after').content;
				
				if (afterContent.indexOf('tabs-disable') != -1) {
					
					if ($el.hasClass('ui-tabs')) {
						$el.tabs("destroy");
					}
					
				} else {
					
					if (!$el.hasClass('ui-tabs')) {
						$el.tabs(options);
					}
					
				}
				
			}
		}
		
		runWatchCSS();
		window.addEventListener("resize", runWatchCSS);
		
	}
	
	// Во время переключение вкладки обновляем высоту readmore (текст с троеточием)
	function updateReadMoreHeight(event, ui) {
		
		let $readMoreElements = $(ui.newPanel).find(readMoreSelector);
		
		if ($readMoreElements.length) {
			
			window.tabInterval = setInterval(function () {
				
				var $el = $readMoreElements.eq(0);
				
				if ($el.is(":visible")) {
					
					$readMoreElements.each(function (i, el) {
						var dotAPI = $(this).children().data('dotdotdot');
						dotAPI.truncate();
					});
					
					clearInterval(window.tabInterval);
					delete window.tabInterval;
					
				}
				
			}, 50);
			
		}
		
	}
	
	// Подготавливаем табы для jquery UI Tabs (требуется связь ссылки с вкладками)
	function prepareTabBox($tabBox) {
		
		var code = $tabBox.attr(attrTabs);
		var $links = $tabBox.find('>ul>li>a');
		var $contents = $tabBox.find('>ul').next().find('>*');
		
		$links.each(function (i, el) {
			
			var $link = $(el);
			
			if ((typeof $link.attr('href') == 'undefined') || $link.attr('href') == '') {
				var attrStr = code + '-' + (i + 1);
				
				$link.attr('href', '#' + attrStr);
				$contents.eq(i).attr('id', attrStr)
			}
			
		});
		
		return $tabBox;
		
	}
	
}